import { parseResponseBody } from "../../../http/parseResponseBody";

const API = "https://pwa-server.test/api/v1/auth";
/**
 *  Update Access token and Refresh Refresh Token (requires an active refresh token)
 *
 * @export
 * @return {boolean}  true | false based on if auth tokens were successfully refreshed
 */
export async function tokenRefresh() {
  // [ ] Update fetch to usePublicFetch (does not require access token)?
  try {
    const response = await fetch(`${API}/token/refresh`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const rawResponse = await parseResponseBody(response);

    if (response.ok && rawResponse?.success)
      return { success: true, data: rawResponse };

    //
    // {
    //   "success": true,
    //   "message": "Login Refreshed.",
    //   "data": {
    //     "csrf_token": "cdc196d592fa521391497f64826b7c45"
    //   }
    // }

    // return response;
    return { success: false, data: rawResponse };
  } catch (e) {
    // return JSON.parse(
    //   `{"success": false,"message": ${
    //     e?.message || "Refresh failed."
    //   },"data": {}}`
    // );

    return { success: false, data: {} };
  }
}
